export default __webpack_public_path__ + "images/7db5bc190bec1935f6d3baf9e907a271-sudoku.svg";